import { ReportProps } from '../../duck/types';
import { Button } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { Icon } from '@lon/shared/components';
import { useThemeStyleValue } from '@lon/shared/hooks';
import { useSsStandardsDownloadReportLazyQuery } from '@lon/shared/requests';
import {
  LevelEnumType,
  SsStandardsAggregationTypeEnum,
} from '@lon/shared/requests';
import { isValidAggrigateKey, isValidEnumKey } from './duck';

interface Props {
  reportProps: ReportProps;
}

const DownloadReport: React.FC<Props> = ({ reportProps }) => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const levelKey = searchParams.get('level') || undefined;
  const { districtId, assignmentId, aggregateBy } = reportProps;

  const colorThemeStyle = useThemeStyleValue('primary.800', 'white');

  const level =
    levelKey && isValidEnumKey(levelKey) ? LevelEnumType[levelKey] : undefined;

  const aggregateByKey =
    aggregateBy && isValidAggrigateKey(aggregateBy)
      ? SsStandardsAggregationTypeEnum[aggregateBy]
      : undefined;

  const [getReportSignedURL, { loading }] =
    useSsStandardsDownloadReportLazyQuery();

  const handleDownloadReport = () => {
    getReportSignedURL({
      fetchPolicy: 'network-only',
      variables: {
        level,
        districtId,
        districtAssessmentId: assignmentId,
        aggregateBy: aggregateByKey,
      },
    })
      .then((response) => {
        const signUrl =
          response.data?.ssStandardsDownloadReport?.signedUrl ?? '';
        if (signUrl) {
          const link = document.createElement('a');
          link.href = signUrl;
          link.download = '';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      })
      .catch((error) => {
        console.error('Error downloading report:', error);
      });
  };

  return (
    <>
      <Button
        color={colorThemeStyle}
        leftIcon={<Icon name="download-outlined" />}
        size="sm"
        className="tr-skip"
        onClick={handleDownloadReport}
        isDisabled={loading}
        isLoading={loading}
        loadingText={t('reportsDashboard.downloadingReport')}
        variant="outline"
      >
        {t('reportsDashboard.downloadReport')}
      </Button>
    </>
  );
};

export default DownloadReport;
